import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-album',
  templateUrl: './album.component.html',
  styleUrls: ['./album.component.scss']
})
export class AlbumComponent implements OnInit {

  numbers = [];

  constructor() { }

  ngOnInit() {
    // for (let i = 64; i < 80; i++)
    //   this.numbers.push(i);
    for (let i = 1; i < 12; i++)
      this.numbers.push(i);
}

}
